import "./App.css";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import MapChart from "./Components/MapChart";
function App() {
  return (
    <div>
      <Header />
      <MapChart />
      <Footer />
    </div>
  );
}

export default App;
